import { render, staticRenderFns } from "./notification-campaign-recipients.vue?vue&type=template&id=4ddbcd61&scoped=true"
import script from "./notification-campaign-recipients.vue?vue&type=script&lang=js"
export * from "./notification-campaign-recipients.vue?vue&type=script&lang=js"
import style0 from "./notification-campaign-recipients.vue?vue&type=style&index=0&id=4ddbcd61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddbcd61",
  null
  
)

export default component.exports